import { CostDetails, Service, StandalonePriceDetails, TenderPriceDetails } from "@/graphql/__generated__/graphql";

/**
 * CalculationOverviewSubject represents a selectable/comparable object in CalculationOverview.
 * Today this supports comparing a Service against another Service or the Tender summary.
 */
export type CalculationOverviewSubject =
  | {
    kind: "service";
    service: Service;
  }
  | {
    kind: "tender";
    tender: TenderPriceDetails;
    tenderCostDetails: CostDetails[];
    standaloneCars?: StandalonePriceDetails;
    standalonePurchases?: StandalonePriceDetails;
  };

/**
 * Generates a unique key for a subject (used for React keys and comparison)
 */
export function getCalculationOverviewSubjectKey(subject: CalculationOverviewSubject): string {
  return subject.kind === "service"
    ? `service-${subject.service.id}`
    : `tender-${subject.tender.id}`;
}
